module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAiCAYAAAAtZZsLAAAAAXNSR0IArs4c6QAAAUpJREFUWEdjZCAAVDwnsX/+K8BCSB058rzMH/7c2Z73E59eRkIGC/vPyPrP8N+bkDpy5BkZGLe+3ZgxjSIHivpPn/qPgSGLHAcQ0sPEwDDt9cbMbGo58DkDA8MJRkbGP4Qsxif/n/E/C8M/BgsGBgZJqjrwPwPDNtbv3GEvd8V9pcSB4m6LuH9zfl3FyMDgNepAckJyNARH0yBauiFYUMPKwdFcjCPHjYYgesCMFjOjxcxoMUOggh7NJKOZZDSTjGYStBAYss0toaBJMox/Wecw/GcwwhurjAzn/jP/Tnm3Lu8JSB3dykGJgOkKvxkYVjH8ZzAl4MDTrAwMYS82ZD6gqwP5QucIsf36HcrAyCSBf2Tg/5O/P3+tfrc97xNdHUhOl5OmDmRgYBjcQx/khhg+fVQZ+hj0w28MnpPYxWk0gPmS+cMfBgIDmAAR6/8ykDHtswAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/phone.png
// module id = 66
// module chunks = 0